import { LoadingButton } from '@mui/lab'
import React, { useState } from 'react'
import DownloadIcon from '@mui/icons-material/Download'
import { orderRepository, userRepository } from '~/src/repositories'
import { useTranslation } from 'react-i18next'

interface CsvParams {
  offset?: number
  limit?: number
  countryId?: string
  email?: string
  name?: string
  keyword?: string
  userId?: number
  includeCanceled?: boolean
  orderedAtBegin?: string
  orderedAtEnd?: string
  detailBaseUrl?: string
}

interface ExportCsvProps {
  exportCsvKey: string
  params: CsvParams
}

export const ExportCsvButton: React.FC<ExportCsvProps> = ({
  exportCsvKey,
  params,
}): JSX.Element => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const formatDateForCsv = (dt: Date) => {
    const y = dt.getFullYear()
    const m = ('00' + (dt.getMonth() + 1)).slice(-2)
    const d = ('00' + dt.getDate()).slice(-2)
    return y + '-' + m + '-' + d
  }
  /**
   * handleExportCsv
   * @param params
   */
  const fetchDataById = async (exportCsvKey: string, params: CsvParams) => {
    switch (exportCsvKey) {
      case 'contact':
        const contactOrdersData = await orderRepository.requestOrderCsv(params)
        return contactOrdersData
      case 'user':
        const UsersData = await userRepository.getUsersCsv(params)
        return UsersData
      default:
    }
  }
  const handleExportCsv = async (exportCsvKey: string, params: CsvParams) => {
    setIsLoading(true)
    const { data } = await fetchDataById(exportCsvKey, params)
    if (data) {
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const url = URL.createObjectURL(new Blob([bom, data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${formatDateForCsv(new Date()) + '_' + exportCsvKey}.csv`)
      link.click()
      link.remove()
      URL.revokeObjectURL(url)
    }
    setIsLoading(false)
  }
  return (
    <LoadingButton
      type="submit"
      loading={isLoading}
      startIcon={<></>}
      loadingPosition="start"
      size={'medium'}
      variant="outlined"
      sx={{
        minWidth: isLoading ? '230px' : '200px',
        ml: '25px',
        height: '40px',
        padding: '7px 22px 7px 19px',
        background: '#FFFFFF',
      }}
      onClick={() => handleExportCsv(exportCsvKey, params)}
    >
      <DownloadIcon sx={{ width: '22px', height: '25px', marginRight: '8px' }} />
      {t('csv_export_button.csv_export')}
    </LoadingButton>
  )
}
